import { Injectable } from '@angular/core';
import {
  Firestore,
  DocumentData,
  QueryConstraint,
  collection,
  collectionData,
  doc,
  docData,
  getCountFromServer,
  orderBy,
  query,
} from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { LogoutService } from 'src/app/shared/services/logout/logout.service';

@Injectable({ providedIn: 'root' })
export class DaoGalleryService {
  constructor(private firestore: Firestore, private Slogout: LogoutService) {}

  getModule(moduleId: string): Observable<DocumentData> {
    const ref = doc(this.firestore, `modules/${moduleId}`);
    return docData(ref).pipe(takeUntil(this.Slogout.logoutSubject));
  }

  getFolder(moduleId: string, folderId: string): Observable<DocumentData> {
    const ref = doc(this.firestore, `modules/${moduleId}/folders/${folderId}`);
    return docData(ref).pipe(takeUntil(this.Slogout.logoutSubject));
  }

  getFolders(moduleId: string, order: any): Observable<DocumentData[]> {
    const ref = collection(this.firestore, `modules/${moduleId}/folders`);
    const qc: QueryConstraint = order === 'custom' ? orderBy('order') : orderBy('createdAt', order);
    const refQ = query(ref, qc);
    return collectionData(refQ).pipe(takeUntil(this.Slogout.logoutSubject));
  }

  getImages(moduleId: string, folderId: string, orderGallery?: string): Observable<DocumentData[]> {
    const ref = collection(this.firestore, `modules/${moduleId}/folders/${folderId}/images`);
    let refQ;

    switch (orderGallery) {
      case 'asc':
        refQ = query(ref, orderBy('name', 'asc'));
        break;
      case 'desc':
        refQ = query(ref, orderBy('name', 'desc'));
        break;
      case 'oldest':
        refQ = query(ref, orderBy('createdAt', 'asc'));
        break;
      case 'recent':
        refQ = query(ref, orderBy('createdAt', 'desc'));
        break;
      default:
        refQ = query(ref, orderBy('createdAt', 'desc'));
        break;
    }

    return collectionData(refQ).pipe(takeUntil(this.Slogout.logoutSubject));
  }

  async getImageCount(moduleId: string, folderId: string): Promise<number> {
    const ref = collection(this.firestore, `modules/${moduleId}/folders/${folderId}/images`);
    const snapshot = await getCountFromServer(ref);
    return snapshot.data().count;
  }

  getSpeakerGalleryImage(eventId: string): Observable<DocumentData[]> {
    const ref = collection(this.firestore, `events/${eventId}/gallery-images`);
    return collectionData(ref).pipe(takeUntil(this.Slogout.logoutSubject));
  }
}
